import React, { Component } from "react";
import {
  Form,
  Input,
  Upload,
  Icon,
  Modal,
  Select,
  Cascader,
  InputNumber,
  Button,
  Radio,
  Drawer,
  Steps,
  message,
} from "antd";
import { api, app, config } from "../../app";
import iosArrowDown from "../../assets/ios-arrow-down.png";
import iosArrowUp from "../../assets/ios-arrow-up.png";
import iosBookmarkOutline from "../../assets/ios-bookmark-outline.png";
import mdTrash from "../../assets/md-trash.png";
import iosCreateOutline from "../../assets/ios-create-outline.png";
import mdAddCircle from "../../assets/md-add-circle.png";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option, OptGroup } = Select;
const Step = Steps.Step;

function formItemLayout(num = 12) {
  return {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: num },
    },
  };
}

class MMAddGood extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: "",
      previewImage2: "",
      previewImage3: "",
      fileList: [], // 商品图片
      fileList2: [], // 商品描述图片
      classImgList: [], //设置图片
      classImg: "",
      previewVisible: false,
      previewVisible2: false,
      previewVisible3: false,
      submit_loading: false,
      detail_visible: false,
      spec_edit_status: false,
      saveLoading: false,
      prevLoading: false,
      delStatus: true,
      data2: [], // 属性数据
      data3: [], // 被删除的属性数据
      nextLoading: false,
      renameSpec: false,
      isExistSpec: false, // 是否存在该规格属性
      itemSpeName: "", // 规格名暂存值

      current: 0,
      images: [],
      manufacturer_img: [],
      classList: [],

      edit_modal: false, // 规格编辑修改弹窗
      spec_data: [], // 规格属性
      data2: [], // 属性数据
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.ClassList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 分类集合
   * @returns {Promise<any>}
   * @constructor
   */
  ClassList = () => {
    const _this = this,
      params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
        type: 1,
      };
    app.post(api.MallClassListing, params).then(({ flag, data, msg }) => {
      if (_this._isMounted) {
        if (flag === 1) {
          const classList = data.map((cla) => {
            return {
              label: cla.class_name,
              value: cla.id,
              children: (cla.subclass || []).map((sub) => {
                return {
                  label: sub.class_name,
                  value: sub.id,
                  children: (sub.subclass || []).map((sub1) => {
                    return {
                      label: sub1.class_name,
                      value: sub1.id,
                    };
                  }),
                };
              }),
            };
          });
          _this.setState({ classList });
        } else {
          app.alert(msg, "warn");
        }
      }
    });
  };

  // 限制图片后缀
  checkImgSuffix = (e) => {
    // 'jpg', 'gif', 'png', 'jpeg'
    if (
      e == "image/jpg" ||
      e == "image/gif" ||
      e == "image/png" ||
      e == "image/jpeg"
    ) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * 商品图片展示
   * @param file
   */
  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  };

  /**
   * 商品图片图片展示
   * @param file
   */
  handlePreview2 = (file) => {
    this.setState({
      previewImage2: file.url || file.thumbUrl,
      previewVisible2: true,
    });
  };

  /**
   * 商品图片图片展示
   * @param file
   */
  handlePreview3 = (file) => {
    console.log(file);

    this.setState({
      previewImage3: file.url || file.thumbUrl,
      previewVisible3: true,
    });
  };

  handleChange = ({ file, fileList }) => {
    this.setState({ fileList }, () => {
      if (!this.checkImgSuffix(file.type)) {
        this.setState({ fileList: [] });
      } else if (file.status === "done") {
        if (file.response.flag === 1) {
          this.setState({ fileList });
          // console.log('上传成功')
        } else {
          app.alert(file.response.msg, "warn");
          this.setState({ fileList: [] });
        }
      }
    });
  };

  handleChange2 = ({ file, fileList2 }) => {
    this.setState({ fileList2 }, () => {
      if (!this.checkImgSuffix(file.type)) {
        this.setState({ fileList2: [] });
      } else if (file.status === "done") {
        if (file.response.flag === 1) {
          console.log(file);
          this.setState({ fileList2 });
          setTimeout(() => {
            console.log(this.state.fileList2);
          }, 500);
        } else {
          app.alert(file.response.msg, "warn");
          this.setState({ fileList2: [] });
        }
      }
    });
  };

  handleChange3 = ({ file, classImgList }) => {
    let { data2, lindex, classImg } = this.state;
    this.setState({ classImgList }, () => {
      if (!this.checkImgSuffix(file.type)) {
        this.setState({ classImgList: [] });
      } else if (file.status === "done") {
        if (file.response.flag === 1) {
          console.log(file);
          data2.forEach((e, i) => {
            if (i == lindex) {
              e.sku_img = file.response.data.url;
            }
          });
          classImg = file.response.data.url;

          console.log(data2);
          this.setState({ classImgList, data2, lindex, classImg });
          setTimeout(() => {
            console.log(this.state.classImgList);
          }, 500);
        } else {
          app.alert(file.response.msg, "warn");
          this.setState({ classImgList: [] });
        }
      }
    });
  };

  handleCancel = () => this.setState({ previewVisible: false });
  handleCancel2 = () => this.setState({ previewVisible2: false });
  handleCancel3 = () => this.setState({ previewVisible3: false });

  /**
   * 提交
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.spec == "" || values.spec == undefined) {
          app.alert("请新增规格", "warn");
          return false;
        }
        const _this = this,
          params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
          };
        values.class_id = values.class_id[values.class_id.length - 1];
        values.images = values.images.file.response.data.url;
        values.manufacturer_img =
          values.manufacturer_img.file.response.data.url;
        values = Object.assign(params, values);
        app.post(api.AdminMallAdd, values).then(({ flag, data, msg }) => {
          if (_this._isMounted) {
            if (flag === 1) {
              app.alert("添加成功", "success");
              _this.props.form.resetFields();
              _this.setState({ fileList: [], fileList2: [] });
            } else {
              app.alert(msg, "warn");
            }
          }
        });
      }
    });
  };

  // 弹出重命名弹窗
  rename = (e, i) => {
    this.setState({ itemSpeName: e, lindex: i, renameSpec: true });
  };

  // 是否展开（闭合）规格类型
  showUp = (e, k) => {
    let { spec_data } = this.state;
    spec_data.forEach((i) => {
      if (i.title == k) {
        if (i.flag == 1) {
          i.flag = 0;
        } else {
          i.flag = 1;
        }
      }
    });
    this.setState({ spec_data });
  };

  // 打开自定义规格单价详情弹框
  open2 = (e, i) => {
    let {
      lindex,
      itemName,
      descValue,
      itemPrice,
      itemStock,
      classImgList,
      classImg,
    } = this.state;
    lindex = i;
    itemName = e.itemName;
    descValue = e.spec_value.join("/");
    itemPrice = e.price;
    itemStock = e.stock;
    // this.selectImg = this.imgUrl + this.classImgList;
    let a = [];
    let obj = {
      show_url: config.imgUrl + e.sku_img,
      url: e.sku_img,
    };
    a.push(obj);

    if (e.sku_img == "") {
      this.setState({ classImgList: [] });
    } else {
      this.setState({ classImgList: a });
    }
    this.setState({
      editSpecDesc: true,
      lindex,
      itemName,
      descValue,
      itemPrice,
      itemStock,
      classImgList,
      classImg: "",
    });
  };

  // 获取下标
  getIndex = (r, p) => {
    this.setState({ lindex: r, voidsName: p });
  };

  onChangeAttr = (ele) => {
    console.log(ele);
    let { spec_data, voidsName, lindex } = this.state;
    spec_data.forEach((e) => {
      if (e.title == voidsName) {
        e.datai.forEach((j, k) => {
          // console.log(ele.target.value + '==>' + j.name)
          // if (k == this.lindex) {
          // j.name = ele.target.value;
          if (ele.target.value == j.name) {
            message.warning("同一规格不能出现相同属性名");
          } else {
            if (k == lindex) {
              console.log("表哥，我出来了哦");
              j.name = ele.target.value;
            }
          }
          // }
        });
      }
    });
    this.setState({ spec_data, voidsName, lindex });

    console.log(spec_data);
  };

  // 移除一项分类数据
  delData = (e, k, x) => {
    let { delStatus, spec_data, data3, data2, isReg } = this.state;
    // item.title, index2, index
    if (delStatus) {
      delStatus = false;
      spec_data.forEach((i, index, arr) => {
        console.log(arr);
        if (e == i.title) {
          // let b = arr[x].datai.length - 1;

          // 处理已有规格下删除已有规格数据
          // 父：title
          let obj = {
            spec_id: i.spec_id,
            name: i.title,
            list: [],
          };

          // 子：list
          let opq = {
            value_id: i.datai[k].value_id,
            name: i.datai[k].name,
            flag: i.datai[k].flag,
            is_delete: 1,
          };
          // spec_name
          obj.list.push(opq);
          // 判断是否已存在该数组
          if (data3 != "") {
            let a = true;
            data3.forEach((i) => {
              // 存在
              if (i.spec_id == obj.spec_id) {
                i.list.push(opq);
                a = false;
              }
            });

            if (a) {
              obj.is_delete = 1;
              data3.push(obj);
            }
          } else {
            // 如果b等于0，则代表该数组已经被完全删除，则写入data3中，否则就在原数组把is_delete改为1
            // if (b == 0) {

            // } else {
            //   this.data3.push(obj);
            // }
            data3.push(obj);
          }

          // 处理完数据后再移除数据
          i.datai.splice(k, 1);
          data2.forEach((sas, sasai) => {
            if (sasai == x) {
              data2.splice(k, 1);
            }
          });
          console.log("===============");
          console.log(e, k, x);
          console.log(data2);

          // 判断属性数组是否为空，是则删除整个规格项
          if (i.datai == "") {
            if (i.value_id == "" || i.value_id == undefined) {
              // console.log(
              //     "判断属性数组是否为空，是则删除整个规格项"
              // );
              if (isReg) {
                data3.forEach((i) => {
                  i.is_delete = 1;
                });
              }
              isReg = false;
              // 初始化时没有该规格名称A，新增规格名称A，执行删除操作，不存入删除数组中
            } else {
              // 处理属性值为空的list的规格数组
              isReg = true;
              data3.push(i);
              data3.forEach((i) => {
                i.is_delete = 1;
              });
            }
            spec_data.splice(x, 1);
          }
        }
      });
      setTimeout(() => {
        this.setState({ delStatus: true });
      }, 200);
      console.log(spec_data);
      console.log(data3);
    } else {
      message.warning("一个一个删除，不要急");
    }
    this.setState({ delStatus, spec_data, data3, data2, isReg });

    // console.log(this.spec_data);
    // console.log(this.data3);
    // console.log('==================================');
  };

  // 显示自定义属性
  handleShowAttr = (n, s) => {
    let { spec_data } = this.state;
    spec_data.forEach((k) => {
      if (k.title == s.title) {
        k.datai.forEach((q, p) => {
          if (p == n) {
            if (q.flag == 1) {
              q.flag = 0;
            } else {
              q.flag = 1;
            }
          }
        });
      }
    });
    this.setState({ spec_data });
  };

  // 添加自定义属性
  addDivAttr = (e) => {
    let { spec_data } = this.state;
    spec_data.forEach((i) => {
      if (e == i.title) {
        if (i.title == "") {
          message.warning("属性名不能为空");
        } else {
          i.flag = 1;
          i.datai.push({
            name: "",
            // statu: false, // 是否删除属性 true 是 false 否
            flag: 1, // 是否显示属性 true 是 false 否
          });
        }
      }
    });
    this.setState({ spec_data });
  };

  // 显示示例图片
  showshili = () => {
    this.review_url = this.imgUrl + "/Uploads/product_spec_img.png";
    this.$viewer.show();
  };

  // 下一步
  next = () => {
    let { spec_data, data2, current } = this.state;
    console.log(spec_data);
    this.setState({ nextLoading: true });
    setTimeout(() => {
      let noRight = false;
      if (spec_data == "") {
        message.warning("请新增规格");
        noRight = true;
        this.setState({ nextLoading: false });
      }

      let newData = [];
      if (spec_data != "" || spec_data != []) {
        spec_data.forEach((i) => {
          i.datai.forEach((j) => {
            newData.push(j.name);
            if (j.name == "") {
              console.log(j);
              message.warning("属性名称不能为空");
              this.setState({ noRight: true,nextLoading:false });
              noRight = true;
            }
          });
        });
      }

      if (!noRight) {
        let lista = [];
        let list = spec_data;
        // console.log(list);
        for (let s = 0; s < list.length; s++) {
          let sarr = list[s].datai;
          console.log(list[s]);
          let lists = [];
          for (let v = 0; v < sarr.length; v++) {
            lists.push(sarr[v].name);
          }
          lista.push(lists);
        }
        console.log(...lista);
        let specData = this.cartesianProductOf(...lista);

        let newData = [];
        specData.forEach((i) => {
          console.log(i);
          let obj = {
            sku_img: "",
            price: "",
            stock: "",
            spec_value: i,
          };
          newData.push(obj);
        });
        if (data2.length > 0) {
          let a = data2;
          a.forEach((i, l) => {
            newData.forEach((j, k) => {
              // console.log(j);
              if (k == l) {
                j.sku_id = i.sku_id;
                j.price = i.price;
                j.stock = i.stock;
                j.sku_img = i.sku_img;
              }
            });
          });
        }

        data2 = newData;
        // console.log(newData);
        // 存在id时调接口保存规格
        // if (this.formInline.id != "") {
        //   // 保存规格
        //   // this.saveLogistics2();
        // } else {
        // }
        this.setState({ current: 1 });
        this.setState({ spec_data, data2 });
        // this.nextLoading = false;
      }
    }, 500);
  };

  // 上一步
  prev = () => {
    this.setState({ prevLoading: true });
    setTimeout(() => {
      this.setState({ prevLoading: false, nextLoading: false, current: 0 });
      // if (this.formInline.id != "") {
      //   this.getGuigeDetail();
      // } else {
      //   this.prevLoading = false;
      //   this.nextLoading = false;
      //   this.current = 0;
      // }
    }, 500);
  };

  // 保存
  save =() =>{
    let { data2 } = this.state;
    this.setState({ saveLoading: true });
    setTimeout(() => {
      let a = true;

      try {
        data2.forEach((i) => {
          if (i.price === "") {
            a = false;
            message.warning("单价不能为空");
            throw new Error();
          }
          if (i.price === 0) {
            a = false;
            message.warning("单价不能为0");
            throw new Error();
          }
          if (i.stock == "") {
            i.stock = 0;
          }
        });
        if (a) {
          // spec_list_json2
          // spec_info_json2
          // 调起保存规格接口
          // this.saveLogistics();
        }
      } catch (e) {
        message.error("出错了");
        console.log(e);
        this.setState({ saveLoading: false });
      }
    }, 500);
  }

  // 处理规格数据：逐层嵌套遍历规格名称数组，
  cartesianProductOf() {
    return Array.prototype.reduce.call(
      arguments,
      function(a, b) {
        var ret = [];
        a.forEach(function(a) {
          b.forEach(function(b) {
            ret.push(a.concat([b]));
          });
        });
        return ret;
      },
      [[]]
    );
  }

  // 点击保存设置的规格名称值
  save_spec_title = (e) => {
    let {
      spec_data,
      isExistSpec,
      spec_edit_status,
      specInputTitle,
    } = this.state;
    let a = spec_data;
    let isTrue = true;
    a.forEach((i) => {
      if (e === i.title) {
        this.setState({ isExistSpec: true, isTrue: false });
        isExistSpec = true;
        isTrue = false;
        message.error("规格名称：" + e + "已存在");
      }
    });
    if (e === "") {
      this.setState({ isTrue: false });
      isTrue = false;
      message.warning("请输入规格名称");
    }

    if (isTrue) {
      this.setState({
        isExistSpec: false,
        spec_edit_status: false,
        specInputTitle: "",
      });
      let b = {
        name: "",
        flag: 1,
      };
      let c = {
        title: e,
        flag: 1,
        datai: [],
      };
      c.datai.push(b);

      spec_data.push(c);
      this.setState({ spec_data });
      console.log(spec_data);
    }
  };

  // 点击保存重命名的规格名称值
  save_spec_rename_title = (e) => {
    let { spec_data, lindex } = this.state;
    let a = true;
    if (e !== "") {
      spec_data.forEach((i) => {
        if (e == i.title) {
          message.warning("该规格名已存在");
          a = false;
        }
      });
    }
    if (a) {
      this.setState({ renameSpec: false, itemSpeName: "" });
      spec_data.forEach((i, j) => {
        if (j == lindex) {
          i.title = e;
        }
      });
    }
    this.setState({ spec_data });
  };

  // 关闭修改规格单价详情弹框
  closeTheEditDrawer = () => {
    this.setState({ editSpecDesc: false, itemSpeName: "", classImgList: [] });
  };

  /**
   * 搜索选择修改
   * @param itemSpeName
   */
  setItemSpeName = (e) => {
    this.setData({ itemSpeName: e.target.value });
  };
  /**
   * 搜索选择修改
   * @param specInputTitle
   */
  handleSelectChange = (e) => {
    this.setData({ specInputTitle: e.target.value });
  };

  // 获取单价框值
  onChangePrice = (ele) => {
    let { data2, lindex, itemPrice } = this.state;
    let osTrue = false;
    if (ele.target.value === 0) {
      osTrue = true;
    }

    if (ele.target.value === "") {
      osTrue = true;
    }

    if (osTrue) {
      message.warning("单价不能为空");
    } else {
      itemPrice = ele.target.value;
      let a = ele.target.value.toString();
      let b = a.indexOf(".");
      let c = a.slice(b + 1);

      // 判断输入值是否正确
      if (!this.checkNumber2(itemPrice)) {
        return message.warning("请输入正确的单价");
      }

      // 判断小数位
      if (b !== -1) {
        // console.log(c.length);
        if (c.length > 4) {
          return message.warning("最多输入两位小数");
        }
      }

      // console.log(d);

      data2.forEach((e, i) => {
        if (i == lindex) {
          if (c.length > 2) {
            if (b !== -1) {
              let d = a.substring(0, b + 3);
              e.price = Number(d);
            } else {
              e.price = Number(a);
            }
          } else {
            e.price = Number(ele.target.value);
          }
        }
      });
    }
    this.setData({ data2, lindex, itemPrice });
  };

  // 获取库存框值
  onChangeStock = (ele) => {
    let { itemStock, data2, lindex } = this.state;
    itemStock = ele.target.value;
    data2.forEach((e, i) => {
      if (i == lindex) {
        e.stock = Number(ele.target.value);
      }
    });
    this.setData({ data2, lindex, itemStock });
  };

  // 获取单价框值（同意设置）
  onChangePrice2 = (ele) => {
    let { itemPrice2, data2, lindex } = this.state;
    let osTrue = false;
    if (ele.target.value === 0) {
      osTrue = true;
    }

    if (ele.target.value === "") {
      osTrue = true;
    }

    if (osTrue) {
      message.warning("单价不能为空");
    } else {
      itemPrice2 = ele.target.value;
      let a = ele.target.value.toString();
      let b = a.indexOf(".");
      let c = a.slice(b + 1);

      // 判断输入值是否正确
      if (!this.checkNumber2(itemPrice2)) {
        return message.warning("请输入正确的单价");
      }

      // 判断小数位
      if (b !== -1) {
        // console.log(c.length);
        if (c.length > 4) {
          return message.warning("最多输入两位小数");
        }
      }

      data2.forEach((e, i) => {
        if (i == lindex) {
          if (b !== -1) {
            let d = a.substring(0, b + 3);
            e.price = Number(d);
          } else {
            e.price = Number(a);
          }
        } else {
          e.price = Number(ele.target.value);
        }
      });
    }
    this.setData({ data2, lindex, itemPrice2 });
  };

  // 获取库存框值（同意设置）
  onChangeStock2 = (ele) => {
    let { itemStock2, data2, lindex } = this.state;
    itemStock2 = ele.target.value;
    data2.forEach((e) => {
      e.stock = ele.target.value;
    });
    this.setData({ data2, lindex, itemStock2 });
  };

  // 保存修改的图片、单价、库存
  save_price_stock2 = () => {
    let { itemPrice2, itemStock2 } = this.state;
    this.setData({ sureSaveLoading: true });

    this.sureSaveLoading = true;
    setTimeout(() => {
      if (!this.checkNumber2(itemPrice2)) {
        return message.warning("请输入正确的单价");
      }
      // 库存只能是整数，不能为小数
      if (!this.checkNumber(itemStock2)) {
        return message.warning("请输入整数形式的库存");
      }
      this.editSpecDesc2 = false;
      this.itemPrice2 = "";
      this.itemStock2 = "";
      this.sureSaveLoading = false;
      this.setData({
        editSpecDesc2: false,
        itemPrice2: "",
        itemStock2: "",
        sureSaveLoading: false,
      });
    }, 500);
  };

  // 验证是否纯数字
  checkNumber = (e) => {
    let a = /^[0-9]*$/;
    return a.test(e);
  };

  // 验证是否数字+小数点
  checkNumber2 = (e) => {
    let a = /^[0-9.]*$/;
    return a.test(e);
  };

  // 保存修改的图片、单价、库存
  save_price_stock = () => {
    let { itemPrice, itemStock } = this.state;
    if (!this.checkNumber2(itemPrice)) {
      return message.warning("请输入正确的单价");
    }
    // 库存只能是整数，不能为小数
    if (!this.checkNumber(itemStock)) {
      return message.warning("请输入整数形式的库存");
    }
    this.setData({ editSpecDesc: false });
  };

  // 关闭规格弹框
  handleCloseSpec_modal = () => {
    this.setData({
      current: 0,
      spec_modal: false,
      specInputTitle: "",
      editSpecDesc: false,
      editSpecDesc2: false,
      renameSpec: false,
      spec_edit_status: false,
      saveLoading: false,
      prevLoading: false,
      nextLoading: false,
      sureSaveLoading: false,
      editLoading: false,
    });
  };

  // 关闭设置规格弹框
  closeTheDrawer = () => {
    this.setData({
      isExistSpec: false,
      spec_edit_status: false,
      specInputTitle: "",
    });
  };

  // 关闭重命名规格弹框
  closeTheRenameDrawer = () => {
    this.setData({
      renameSpec: false,
      itemSpeName: "",
    });
  };

  /**
   * 商品图片上传前
   * @param file
   * @param fileList
   * @returns {boolean}
   */
  handleBeforeUpload = (file) => {
    if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/gif" ||
      file.type === "image/png"
    ) {
      return true;
    }
    app.alert("请上传jpg,jpeg,png,gif格式的图片", "warn");
    this.setState({ fileList: [] });
    return false;
  };

  /**
   * 商品描述图片上传前
   * @param file
   * @param fileList2
   * @returns {boolean}
   */
  handleBeforeUpload2 = (file) => {
    if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/gif" ||
      file.type === "image/png"
    ) {
      return true;
    }
    app.alert("请上传jpg,jpeg,png,gif格式的图片", "warn");
    this.setState({ fileList2: [] });
    return false;
  };

  /**
   * 商品描述图片上传前
   * @param file
   * @param classImgList
   * @returns {boolean}
   */
  handleBeforeUpload3 = (file) => {
    if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/gif" ||
      file.type === "image/png"
    ) {
      return true;
    }
    app.alert("请上传jpg,jpeg,png,gif格式的图片", "warn");
    this.setState({ classImgList: [], classImg: "" });
    return false;
  };

  // // 打开新增（修改）规格弹窗
  openSpecBox = () => {
    this.setData({ detail_visible: true });

    // const {edit_modal} = this.state;

    // // 关闭弹窗
    // if (edit_modal) {
    //      this.setData({
    //         edit_modal: false,
    //         spec_data: [],
    //         data2: [],
    //     });
    // } else {
    //     // 打开弹窗
    //     // 判断是新增还是
    //      this.setData({
    //         edit_modal: true,
    //         spec_data: [],
    //         data2: [],
    //     });
    // }
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form,
      {
        previewVisible,
        previewVisible2,
        previewVisible3,
        previewImage,
        previewImage2,
        previewImage3,
        fileList,
        fileList2,
        classImgList,
        classImg,
        classList,
        detail_visible,
        spec_data,
        current,
        spec_edit_status,
        nextLoading,
        isExistSpec,
        specInputTitle,
        renameSpec,
        itemSpeName,
        data2,
        prevLoading,
        saveLoading,
        editSpecDesc,
        descValue,
        itemPrice,
        itemStock,
        sureSaveLoading,
        itemStock2,
        itemPrice2,
        editSpecDesc2,
      } = this.state,
      uploadButton = (
        <div>
          <Icon type="plus" />
          <div className="ant-upload-text">上传照片</div>
        </div>
      );
    return (
      <div className="mall-manage-add-good">
        <div className="page-title">商品添加</div>
        <div className="page-content">
          <Form onSubmit={this.handleSubmit} style={{ paddingBottom: 20 }}>
            <FormItem {...formItemLayout(4)} label="商品分类">
              {getFieldDecorator("class_id", {
                rules: [
                  {
                    required: true,
                    message: "请选择商品分类",
                  },
                ],
              })(
                <Cascader
                  notFoundContent="暂无商品分类"
                  options={classList}
                  placeholder="请选择商品分类"
                  expandTrigger="hover"
                  changeOnSelect={true}
                />
              )}
            </FormItem>

            <FormItem label="商品图片(首张为封面图)" {...formItemLayout()}>
              {getFieldDecorator("images", {
                rules: [{ required: true, message: "请上传商品图片!" }],
              })(
                <Upload
                  multiple={true}
                  action={config.serverUrl + api.ImageUpload}
                  data={{
                    indexno: app.getData("indexno"),
                    account: app.getData("account"),
                    token: app.getData("token"),
                    upload_type: "mall",
                  }}
                  name="image"
                  fileList={fileList}
                  listType="picture-card"
                  accept="image/gif, image/jpeg, image/jpg, image/png"
                  onPreview={this.handlePreview}
                  onChange={this.handleChange}
                  beforeUpload={this.handleBeforeUpload}
                >
                  {fileList.length > 0 ? null : uploadButton}
                </Upload>
              )}
              <Modal
                visible={previewVisible}
                footer={null}
                onCancel={this.handleCancel}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            </FormItem>

            <FormItem {...formItemLayout()} label="商品名称">
              {getFieldDecorator("name", {
                rules: [
                  {
                    required: true,
                    message: "请填写商品名称",
                  },
                ],
              })(<Input placeholder="请填写商品名称" />)}
            </FormItem>

            <FormItem {...formItemLayout()} label="商品描述(文字)">
              {getFieldDecorator("remark", {
                rules: [
                  {
                    required: true,
                    message: "请输入商品描述",
                  },
                ],
              })(
                <Input.TextArea
                  placeholder="请输入商品描述"
                  autosize={{ minRows: 6, maxRows: 10 }}
                />
              )}
            </FormItem>

            <FormItem label="商品描述(图片)" {...formItemLayout()}>
              {getFieldDecorator("manufacturer_img", {
                rules: [{ required: true, message: "请上传商品描述图片!" }],
              })(
                <Upload
                  multiple={true}
                  action={config.serverUrl + api.ImageUpload}
                  data={{
                    indexno: app.getData("indexno"),
                    account: app.getData("account"),
                    token: app.getData("token"),
                    upload_type: "mall",
                  }}
                  name="image"
                  fileList2={fileList2}
                  listType="picture-card"
                  accept="image/gif, image/jpeg, image/jpg, image/png"
                  onPreview={this.handlePreview2}
                  onChange={() => this.handleChange2}
                  beforeUpload={this.handleBeforeUpload2}
                >
                  {fileList2.length > 0 ? null : uploadButton}
                </Upload>
              )}
              <Modal
                visible={previewVisible2}
                footer={null}
                onCancel={this.handleCancel2}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage2}
                />
              </Modal>
            </FormItem>

            <FormItem {...formItemLayout()} label="店家提示">
              {getFieldDecorator("statement", {
                rules: [
                  {
                    required: false,
                    message: "请填写店家提示",
                  },
                ],
              })(
                <Input.TextArea
                  placeholder="请输入店家提示"
                  autosize={{ minRows: 6, maxRows: 10 }}
                />
              )}
            </FormItem>

            <FormItem {...formItemLayout(4)} label="商品售价(元)">
              {getFieldDecorator("price", {
                rules: [
                  {
                    required: true,
                    message: "请填写商品售价",
                  },
                ],
              })(
                <InputNumber
                  precision={2}
                  style={{ width: "100%" }}
                  placeholder="请填写商品售价"
                />,
                <span style={{ color: "red" }}>
                  {" "}
                  此价格在商品列表显示，一般为商品最低价{" "}
                </span>
              )}
            </FormItem>

            <div>
              <div
                style={{
                  position: "relative",
                  top: "30px",
                  color: "red",
                  left: "calc(24% - 70px)",
                }}
              >
                *
              </div>
              <FormItem {...formItemLayout(4)} label="商品规格">
                {getFieldDecorator("spec", {
                  rules: [
                    {
                      required: false,
                      message: "请新增规格",
                    },
                  ],
                })(
                  <Button
                    onClick={() => this.openSpecBox()}
                    style={{ width: "100%" }}
                  >
                    + 新增规格
                  </Button>
                )}
              </FormItem>
            </div>

            <FormItem {...formItemLayout(4)} label="商品重量(kg)">
              {getFieldDecorator("weight", {
                rules: [
                  {
                    required: true,
                    message: "请输入商品重量",
                  },
                ],
              })(
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="请输入商品重量"
                />
              )}
            </FormItem>

            <FormItem {...formItemLayout(4)} label="生产数量">
              {getFieldDecorator("produce_number", {
                rules: [
                  {
                    required: true,
                    message: "请填写生产数量",
                  },
                ],
              })(
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="请填写生产数量"
                />
              )}
            </FormItem>

            <FormItem {...formItemLayout(8)} label="是否审核">
              {getFieldDecorator("is_audit", {
                rules: [
                  {
                    required: true,
                    message: "请选择是否审核",
                  },
                ],
              })(
                <RadioGroup placeholder="请选择是否审核">
                  <Radio value="1">是</Radio>
                  <Radio value="0">否</Radio>
                </RadioGroup>
              )}
            </FormItem>

            <FormItem {...formItemLayout(8)} label="是否限购">
              {getFieldDecorator("is_astrict", {
                rules: [
                  {
                    required: true,
                    message: "请选择是否限购",
                  },
                ],
              })(
                <RadioGroup placeholder="请选择是否限购">
                  <Radio value="1">是</Radio>
                  <Radio value="0">否</Radio>
                </RadioGroup>
              )}
            </FormItem>

            {getFieldValue("is_astrict") === "1" ? (
              <div>
                <FormItem {...formItemLayout(4)} label="限购次数">
                  {getFieldDecorator("astrict_how", {
                    rules: [
                      { required: true, message: "请输入限购次数" },
                      { type: "integer", min: 1, message: "最少一件" },
                    ],
                  })(
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="请填写限购次数"
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout(4)} label="限购数量">
                  {getFieldDecorator("astrict_number", {
                    rules: [
                      { required: true, message: "请输入限购数量" },
                      { type: "integer", min: 1, message: "最少一件" },
                    ],
                  })(
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="请填写限购数量"
                    />
                  )}
                </FormItem>
              </div>
            ) : null}

            <FormItem {...formItemLayout(8)} label="是否发货队部">
              {getFieldDecorator("is_team", {
                rules: [
                  {
                    required: true,
                    message: "请选择是否发货队部",
                  },
                ],
              })(
                <RadioGroup placeholder="请选择是否发货队部">
                  <Radio value="1">是</Radio>
                  <Radio value="0">否</Radio>
                </RadioGroup>
              )}
            </FormItem>

            <FormItem {...formItemLayout(8)} label="商品状态">
              {getFieldDecorator("status", {
                rules: [
                  {
                    required: true,
                    message: "请选择商品状态",
                  },
                ],
              })(
                <RadioGroup placeholder="请选择商品状态">
                  <Radio value="1">上架</Radio>
                  <Radio value="0">下架</Radio>
                </RadioGroup>
              )}
            </FormItem>

            {/* <FormItem
                            {...formItemLayout(4)}
                            label="商品状态"
                        >
                            {getFieldDecorator('status', {
                                rules: [{
                                    required: true, message: '请选择商品状态'
                                }],
                            })(
                                <Select placeholder="请选择商品状态">
                                    <Option value="1">上架</Option>
                                    <Option value="0">下架</Option>
                                </Select>
                            )}
                        </FormItem> */}

            <div style={{ textAlign: "center" }}>
              <Button type="primary" onClick={this.handleSubmit}>
                添加
              </Button>
            </div>
          </Form>
          <Drawer
            placement="right"
            onClose={() => this.setData({ detail_visible: false })}
            visible={detail_visible}
            width={600}
            bodyStyle={{
              overflowY: "auto",
              height: "calc(100% - 55px)",
              padding: 20,
            }}
            destroyOnClose={true}
            className="spec_box"
          >
            <div style={{ minHeight: "367px" }}>
              <div slot="title">
                <div>
                  <h3
                    style={{
                      color: "#000",
                      marginRight: "8px",
                      display: "inline-block",
                    }}
                  >
                    {spec_data.length !== 0 ? "修改规格" : "新增规格"}
                  </h3>
                  <span style={{ color: " #e4393c" }}>
                    隐藏状态的属性将不显示在用户端
                  </span>
                </div>
              </div>
              <p>当前正在进行第 {current + 1} 步</p>
              <Steps className="spec_step" current={current}>
                <Step title="设置规格名以及规格属性"></Step>
                <Step title="设置单价和库存"></Step>
              </Steps>
              {/* 设置规格名以及规格属性 */}
              {current === 0 && (
                <div className="spec_main">
                  {spec_data.length == 0 && (
                    <span>暂无数据，点击右下角新增规格</span>
                  )}

                  <div>
                    {spec_data.map((item, index) => (
                      <div className="spec" key={index}>
                        <div className="spec_title">
                          <div className="title">{item.title}</div>

                          <div className="remaneBox">
                            <a
                              className="rename"
                              onClick={() => this.rename(item.title, index)}
                              href="#"
                            >
                              重命名
                            </a>

                            <div
                              onClick={() => this.showUp(item.flag, item.title)}
                            >
                              {item.flag === 1 ? (
                                <img src={iosArrowDown}></img>
                              ) : (
                                <img src={iosArrowUp}></img>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="spec_name">
                          {item.datai.map((item2, index2) => (
                            <div key={index2}>
                              {item.flag === 1 ? (
                                <Input
                                  className="inp"
                                  value={item2.name}
                                  placeholder="请输入属性名称"
                                  style={{ marginBottom: "16px" }}
                                  onFocus={() =>
                                    this.getIndex(index2, item.title)
                                  }
                                  onChange={this.onChangeAttr}
                                  prefix={
                                    <div style={{ cursor: "pointer" }}>
                                      <img
                                        onClick={() =>
                                          this.delData(
                                            item.title,
                                            index2,
                                            index
                                          )
                                        }
                                        src={mdTrash}
                                      ></img>
                                    </div>
                                  }
                                  suffix={
                                    <div
                                      onClick={() =>
                                        this.handleShowAttr(index2, item)
                                      }
                                    >
                                      <div
                                        style={{ lineHeight: "1px" }}
                                        className={
                                          item2.flag === 1
                                            ? "suffix"
                                            : "suffix active"
                                        }
                                      >
                                        <span
                                          style={{ lineHeight: "1px" }}
                                          className={
                                            item2.flag === 1
                                              ? "icon_circle"
                                              : "icon_circle active2"
                                          }
                                        ></span>
                                        <span
                                          style={{ lineHeight: "22px" }}
                                          className={
                                            !item2.flag === 1
                                              ? "icon_text"
                                              : "icon_text active3"
                                          }
                                        >
                                          {item2.flag === 1 ? "显示" : "隐藏"}
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              ) : null}
                            </div>
                          ))}
                          <a
                            style={{ fontSize: 16 }}
                            onClick={() => this.addDivAttr(item.title)}
                            href="#"
                          >
                            +添加自定义属性
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* 设置单价和库存 */}

              {current === 1 && (
                <div className="spec_desc">
                  {data2.map((item, index) => (
                    <div
                      className="item"
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={() => this.open2(item, index)}
                    >
                      <div className="imgBox">
                        {item.sku_img ? (
                          <img
                            className="img"
                            src={config.imgUrl + item.sku_img}
                          ></img>
                        ) : (
                          <img src={mdAddCircle}></img>
                        )}
                      </div>
                      <div className="price">
                        <div className="bottom">
                          <span className="text">
                            {item.spec_value.join(",")}
                          </span>
                          <img
                            style={{ width: 14, height: 14 }}
                            src={iosCreateOutline}
                          ></img>
                        </div>
                        <div className="top">
                          <span className="price-p">
                            销售单价：{item.price ? item.price : 0}
                          </span>
                          <span className="stock-p">
                            库存：{item.stock ? item.stock : 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* 占位 */}
              <div
                style={{ height: "16px", borderTop: "1px solid #f0f0f0" }}
              ></div>

              {current === 0 && (
                <div>
                  <div
                    style={{
                      color: "#e4393c",
                      float: "left",
                      cursor: "pointer",
                      fontSize: "24px",
                    }}
                    onClick={this.showshili}
                  >
                    <img src={iosBookmarkOutline} style={{ margin: 5 }}></img>
                    示例
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {current === 0 && (
                      <Button
                        type="primary"
                        style={{ marginRight: "16px" }}
                        onClick={() => {
                          this.setData({ spec_edit_status: true });
                        }}
                      >
                        新增规格
                      </Button>
                    )}
                    <Button
                      type="primary"
                      loading={nextLoading}
                      onClick={this.next}
                    >
                      下一步
                    </Button>
                  </div>
                </div>
              )}
              {current === 1 && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="default"
                    style={{ marginRight: 16 }}
                    onClick={() => this.setData({ editSpecDesc2: true })}
                  >
                    统一设置
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginRight: 16 }}
                    loading={prevLoading}
                    onClick={this.prev}
                  >
                    上一步
                  </Button>
                  <Button
                    type="primary"
                    loading={saveLoading}
                    onClick={this.save}
                  >
                    保存
                  </Button>
                </div>
              )}
            </div>
          </Drawer>

          <Drawer
            closable={true}
            maskClosable={false}
            visible={spec_edit_status}
            onClose={this.closeTheDrawer}
            width={530}
          >
            <div>
              <p style={{ color: "#e4393c" }}>例如：颜色、尺寸、码数</p>
              <h3 style={{ color: " #000", marginBottom: "16px" }}>设置规格</h3>
            </div>
            <Input.Search
              enterButton="确定"
              value={specInputTitle}
              onChange={this.handleSelectChange}
              onSearch={this.save_spec_title}
              placeholder="请输入规格名称.."
            />
            {isExistSpec && (
              <div style={{ color: "red" }}>该规格已存在,请更换名称</div>
            )}
          </Drawer>

          <Drawer
            title="规格名"
            maskClosable={false}
            visible={renameSpec}
            onClose={this.closeTheRenameDrawer}
            width={530}
            placement="right" // 可根据实际需要调整抽屉位置
          >
            <Input.Search
              enterButton="确定"
              value={itemSpeName}
              onChange={this.setItemSpeName}
              onSearch={this.save_spec_rename_title}
              placeholder="请输入规格名.."
            />
          </Drawer>

          <Drawer
            title="设置图片、单价、库存"
            visible={editSpecDesc}
            onClose={this.closeTheEditDrawer}
            destroyOnClose={true}
            width={524}
            maskClosable={false}
            placement="right"
          >
            <div className="price_stock_img_box">
              <div className="img_box">
                <Upload
                  multiple={true}
                  action={config.serverUrl + api.ImageUpload}
                  data={{
                    indexno: app.getData("indexno"),
                    account: app.getData("account"),
                    token: app.getData("token"),
                    upload_type: "mall",
                  }}
                  name="image"
                  classImgList={classImgList}
                  listType="picture-card"
                  accept="image/gif, image/jpeg, image/jpg, image/png"
                  onPreview={this.handlePreview3}
                  onChange={this.handleChange3}
                  beforeUpload={this.handleBeforeUpload3}
                >
                  {classImg != "" ? null : uploadButton}
                </Upload>
                <Modal
                  visible={previewVisible3}
                  footer={null}
                  onCancel={this.handleCancel3}
                >
                  <img
                    alt="example"
                    style={{ width: "100%" }}
                    src={previewImage3}
                  />
                </Modal>
                {/* UploadFile 组件对应的内容在这里实现 */}
              </div>

              <div className="title2">{descValue}</div>

              <div className="price-stock-box">
                <div className="price-stock-item" style={{ marginBottom: 16 }}>
                  <span className="mun">销售单价：</span>
                  <Input
                    value={itemPrice}
                    onChange={this.onChangePrice}
                    placeholder="请输入该规格的单价"
                  />
                </div>

                <div className="price-stock-item">
                  <span className="mun">库存：</span>
                  <Input
                    value={itemStock}
                    onChange={this.onChangeStock}
                    placeholder="请输入该规格的库存数量"
                  />
                </div>
              </div>

              <Button
                style={{ display: "block", margin: "20px auto", width: "90%" }}
                type="primary"
                className="save_price_stock"
                onClick={this.save_price_stock}
              >
                确定
              </Button>
            </div>
          </Drawer>

          {/* 统一设置 */}
          <Drawer
            title="统一设置单价、库存"
            visible={editSpecDesc2}
            onClose={this.closeTheEditDrawer2}
            maskClosable={false}
            destroyOnClose={true}
            closable={false}
            placement="right"
          >
            <div className="price_stock_img_box">
              <div className="price-stock-box">
                <div className="price-stock-item" style={{ marginBottom: 16 }}>
                  <span className="mun">销售单价：</span>
                  <Input
                    value={itemPrice2}
                    onChange={this.onChangePrice2}
                    placeholder="请输入该规格的单价"
                  />
                </div>

                <div className="price-stock-item">
                  <span className="mun">库存：</span>
                  <Input
                    value={itemStock2}
                    onChange={this.onChangeStock2}
                    placeholder="请输入该规格的库存数量"
                  />
                </div>
              </div>

              <Button
                style={{ display: "block", margin: "20px auto", width: "90%" }}
                type="primary"
                className="save_price_stock"
                loading={sureSaveLoading}
                onClick={this.save_price_stock2}
              >
                确定
              </Button>
            </div>
          </Drawer>
        </div>
      </div>
    );
  }
}

export default Form.create()(MMAddGood);



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMAddGood.jsx